import React, { useCallback } from 'react';
import { useLocation } from 'react-router-dom';

import PageTemplate from '../../../components/common/template/PageTemplate';
import { Flex } from '../../../components/common/atom/Layout';
import { Video } from '../../../components/common/atom/Video';
import { DownloadButton } from '../../../components/common/molecules/DownloadButton';
import { BABYFACE_URL } from '../../../lib/routes/Routes';

const HeRecordingPlayer = () => {
  const location = useLocation();
  const { recording } = location.state || {};

  const downloadVideo = useCallback(() => {
    window.open(`${BABYFACE_URL}/he/recording/${recording.id}/download`);
  }, []);

  return (
    <PageTemplate title={PAGE_TITLE}>
      <Flex column>
        <Video
          src={recording.url}
          style={{
            maxWidth: '100%',
          }}
        />
        <DownloadButton type="video" eventHandler={downloadVideo} />
      </Flex>
    </PageTemplate>
  );
}

export default React.memo(HeRecordingPlayer);

const PAGE_TITLE = '초음파 동영상 보기';
